import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { CleanUnorderedList } from 'src/common/components/List';
import { media } from 'src/config/breakpoints';
import { colors } from 'src/config/colors';
import { CourseParameter } from 'src/common/models/course';

const Container = styled(CleanUnorderedList)`
  li {
    padding-left: 1.875rem;
    position: relative;

    ${media.w.min.px768(css`
      padding-left: 2.75rem;
    `)};

    &::before {
      color: ${colors.pfp3bis};
      content: '–';
      left: 0;
      position: absolute;
      text-align: right;
      top: 0;
      width: 0.8125rem;

      ${media.w.min.px768(css`
        width: 1.125rem;
      `)};
    }
  }
`;

export interface CourseParameterListProps {
  items: CourseParameter[];
}

export const CourseParameterList: FC<CourseParameterListProps> = ({ items }) => {
  return (
    <Container>
      {items.map((item) => (
        <li key={item.id}>{item.value}</li>
      ))}
    </Container>
  );
};
